import { ITagResult } from '../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from './TagRequest';

import {IAnalyticsExtWorkbookId} from '../../../settings/types/ISiteSettingsForSiteAdmin';

export type IRemoveAnalyticsExtConnectionForWorkbookResult = ITagResult;

export class RemoveAnalyticsExtConnectionForWorkbookRequest extends TagRequest<IAnalyticsExtWorkbookId, IRemoveAnalyticsExtConnectionForWorkbookResult> {
  constructor(WorkbookId: IAnalyticsExtWorkbookId) {
    super('analyticsextensions', 'deleteConnectionFromWorkbook', WorkbookId);
  }
}